import { confirm } from './components/confirm/Confirm';
import getDeleteMessage from './utils/messages';

function reportTemplatesModule(): void {
    function handleClick(event: MouseEvent): void {
        event.preventDefault();
        const target = event.currentTarget as HTMLAnchorElement;

        const templateIsUsed = target.dataset.isUsed === 'True';
        const nameElement = target.parentElement?.parentElement?.querySelector<HTMLElement>(
            `[data-label=${gettext('NAME')}]`
        );

        if (!nameElement) {
            throw new Error('Template name element not found.');
        }

        const templateName = nameElement.textContent || '';

        const message = templateIsUsed
            ? interpolate(gettext('TEMPLATE_REVERT_MESSAGE'), [templateName])
            : getDeleteMessage(gettext('TEMPLATE'), templateName);

        confirm({
            markdownMessage: message,
            onConfirm() {
                const href = target.getAttribute('href');

                if (!href) {
                    throw new Error('Target href was not found.');
                }
                window.location.href = href;
            },
        });
    }

    const reportTemplateDeleteIcons = document.querySelectorAll<HTMLAnchorElement>(
        '.report-templates .template-options > a[data-is-used]'
    );
    reportTemplateDeleteIcons.forEach((deleteIcon) => {
        deleteIcon.addEventListener('click', handleClick);
    });
}

export default reportTemplatesModule;
